import { useTranslation } from "../../../../locale/useTranslation";

const PreferenceRoundButton = (props) => {
    const lang=useTranslation();
    
    return <button  title={lang.preference_button_tooltip} type="submit" onClick={props.onClick} style={{margin:"0px 01px"}} className="btn btn-default btn-circle btn-my">
       <i className="fa fa-gear fa-fw img-circle"></i>
      
    </button>
}

export default PreferenceRoundButton;
